// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2myNk","placeholdersHeader":"styles_placeholdersHeader__2WmL9","editorStyle":"styles_editorStyle__17k_U","placeholdersBox":"styles_placeholdersBox__1eyJ7"};